import { Add } from '@mui/icons-material';
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

interface CheckboxWithButtonProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  chipCount: number;
  onButtonClick: () => void;
  disabled?: boolean;
  buttonDisabled?: boolean;
}

export const CheckboxWithButton: React.FC<CheckboxWithButtonProps> = ({
  label,
  checked,
  onChange,
  chipCount,
  onButtonClick,
  disabled = false,
  buttonDisabled = false,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            color="primary"
            disabled={disabled}
          />
        }
        label={label}
      />
      <IconButton
        onClick={onButtonClick}
        disabled={disabled || buttonDisabled}
        size="small"
        style={{ position: 'relative' }}
      >
        <Add />
        {chipCount > 0 && (
          <Typography
            style={{
              position: 'absolute',
              bottom: -5,
              right: 0,
              color: 'white',
              fontSize: 10,
              padding: '2px 6px',
              borderRadius: 50,
              fontWeight: '400',
              margin: '1px 2px',
              backgroundColor: '#297dff',
            }}
          >
            {chipCount}
          </Typography>
        )}
      </IconButton>
    </div>
  );
};
